import html2canvas from 'html2canvas';
export function downloadDailyMenuImage(width) {
    const container = document.querySelector('.daily-menu');

    container.style.width = `${width}px`;
    container.style.height = `100%`;
    container.style.overflow = 'auto';

    html2canvas(container).then(canvas => {
        const link = document.createElement('a');
        link.download = 'daily-menu.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
    });

    container.style.width = '';
    container.style.height = '';
}
